import { Component } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { ListaFuncionalidadeComponent } from '../../../shared/components/lista-funcionalidade/lista-funcionalidade.component';
import { HeaderComponent } from '../../../shared/components/header/header.component';

@Component({
  selector: 'app-configuracoes-home',
  imports: [
    ListaFuncionalidadeComponent,
    HeaderComponent
  ],
  templateUrl: './configuracoes-home.component.html',
  styleUrl: './configuracoes-home.component.css',
})
export class ConfiguracoesHomeComponent {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor() {
    this.moduloEnum = ModuloEnum.Configuracoes;
    this.funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Usuario;
  }
}
